export default function Feed() {
    return <div className="page">Це стрічка новин</div>;
  }

